import React from 'react';
import AboutAdvantage from '../COMPONENT/aboutAdvantage';
import AboutArticle from '../COMPONENT/aboutArticle';
import AboutCounter from '../COMPONENT/aboutCounter';
import Header from '../COMPONENT/header'
import SideBar from '../COMPONENT/sideBar'
import MobileNav from '../COMPONENT/mobileNav'
import Footer from '../COMPONENT/footer'
import { Helmet } from 'react-helmet';

export default function About() {
  return (
    <div>

      <Header/>
      <SideBar/>
      <MobileNav/>

      <section class="single-banner">
         <div class="container">
            <div class="row">
               <div class="col-lg-12">
                  <div class="single-content">
                     <h2>about company</h2>
                     <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">about</li>
                     </ol>
                  </div>
               </div>
            </div>
         </div>
      </section>
      
      <AboutArticle/>
      <AboutAdvantage/>
      <AboutCounter/>
      <Footer/>

      <Helmet>
    <script type="media_type" src="../js/vendor/jquery-1.12.4.min.js"></script>
    <script type="media_type" src="../js/vendor/popper.min.js"></script>
    <script type="media_type" src="../js/vendor/bootstrap.min.js"></script>
    <script type="media_type"src="../js/custom/main.js"></script>
    <script type="media_type"src="../js/vendor/slick.min.js"></script>
    <script type="media_type"src="../js/custom/slick.js"></script>
    </Helmet>
    </div>
  )
}
